
import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

interface PriorityCheckboxProps {
  isPriorityHigh: boolean;
  onPriorityChange: (checked: boolean) => void;
}

const PriorityCheckbox = ({ isPriorityHigh, onPriorityChange }: PriorityCheckboxProps) => {
  return (
    <div className="space-y-2 flex items-center space-x-2">
      <Checkbox 
        id="priority-checkbox" 
        checked={isPriorityHigh}
        onCheckedChange={(checked) => {
          onPriorityChange(checked === true);
        }}
      />
      <Label htmlFor="priority-checkbox" className="font-medium cursor-pointer">
        Hoge prioriteit
      </Label>
    </div>
  );
};

export default PriorityCheckbox;
